/**
 * GPS provider dispatcher (modular, backward-compatible).
 *
 * Each provider is an isolated adapter exposing the same async interface:
 *   fetchAll(settings) → { success, error, data: [normalized device array] }
 *
 * Adding a provider = add an adapter + one line in PROVIDERS. Existing providers
 * are never touched. Default is the current GPSWOX/Traccar path, so behavior is
 * identical unless an agency explicitly selects another provider.
 */

import { traccarFetchAll } from '../features/gps/utils/traccar';
import { afoulkiFetchAll } from '../features/gps/utils/afoulki';
import { trackyFetchAll } from '../features/gps/utils/tracky';
import { iopgpsFetchAll } from '../features/gps/utils/iopgps';

// Selectable providers (for the Settings dropdown).
export const GPS_PROVIDERS = [
  { key: 'traccar', fr: 'GPSWOX / Traccar (actuel)', ar: 'GPSWOX / Traccar (الحالي)' },
  { key: 'afoulki', fr: 'Afoulki GPS', ar: 'Afoulki GPS' },
  { key: 'tracky', fr: 'Tracky (web.tracky.ma)', ar: 'Tracky (web.tracky.ma)' },
  { key: 'iopgps', fr: 'IOPGPS (iopgps.com)', ar: 'IOPGPS (iopgps.com)' },
];

// Adapter registry — isolated per provider.
const ADAPTERS = {
  traccar: traccarFetchAll,
  afoulki: afoulkiFetchAll,
  tracky: trackyFetchAll,
  iopgps: iopgpsFetchAll,
};

/**
 * Fetch all vehicles from the configured provider.
 * Defaults to 'traccar' so existing setups are unaffected.
 */
export const fetchAllGps = async (settings = {}) => {
  const key = settings.gpsProvider || 'traccar';
  const adapter = ADAPTERS[key] || traccarFetchAll;
  try {
    return await adapter(settings);
  } catch (err) {
    return { success: false, error: err && err.message ? err.message : 'GPS provider error', data: [] };
  }
};
